// @flow
export const DIRECT_DEBIT_BLZ_ACCOUNT_NUMBER: "DIRECT_DEBIT_BLZ_ACCOUNT_NUMBER" = "DIRECT_DEBIT_BLZ_ACCOUNT_NUMBER";
export const DIRECT_DEBIT_IBAN: "DIRECT_DEBIT_IBAN" = "DIRECT_DEBIT_IBAN";
export const REMITTANCE: "REMITTANCE" = "REMITTANCE";
export const IMPORT_FROM_DELIVERY_ADDRESS: "IMPORT_FROM_DELIVERY_ADDRESS" = "IMPORT_FROM_DELIVERY_ADDRESS";
export const DIFFERENT_ACCOUNT_OWNER: "DIFFERENT_ACCOUNT_OWNER" = "DIFFERENT_ACCOUNT_OWNER";
